module.exports = __webpack_public_path__ + "img/goal2.05192f87.jpg";